// extracted by mini-css-extract-plugin
module.exports = {"mega-menu-navigation":"navigation_mega-menu-navigation__RQzGm"};